import Cards from "./Cards";

const About = () => {
  return (
    <div className="px-8 sm:px-10 md:px-16 bg-bg-primary py-20">
      <h1 className="text-5xl font-black py-10">ABOUT US</h1>
      <div className="grid grid-rows-3 md:grid-cols-2 md:grid-rows-2 gap-y-7 relative w-full">
        <div className="row-span-2 h-full flex items-center justify-center">
          <div className="z-10 my-20">
            <div className="even:mx-2 my-2 rounded-md p-[2px] bg-gradient-to-r from-accent via-[#1C8D8E] to-[#2A5E6F]">
              <span className="block text-m text-white rounded-md bg-bg-primary object-fill">
                <iframe
                  src="https://drive.google.com/file/d/1DmqKCc0pKpStyrjOSJ0xmLSo_Iu4JRBm/preview"
                  className="w-[340px] h-[240px] md:w-[440px] md:h-[280px] object-fill rounded-md"
                  allow="autoplay"
                  title="Intro Video"
                  data-twe-lazy-load-init
                ></iframe>
              </span>
            </div>
          </div>
        </div>
        <div className="">
          <p className="z-10 text-base col-span-2 md:text-xl lg:text-2xl">
            We started our career on editing wedding videos and photos then
            eventually moved into editing social media videos creating
            high-quality contents for social media platforms. This team consists
            some of the best video editors here in the Philippines that has 5
            years plus experience in the industry.
          </p>
        </div>
        <div className="">
          <p className="z-10 text-base col-span-2 md:text-xl lg:text-2xl">
            We set proper expectations and aim for achievable results, ensuring
            that our goals are realistic and attainable while maintaining a high
            standard of quality and performance.
          </p>
        </div>
        <div className="h-52 w-52 bg-transparent-accent absolute top-40 left-10 z-1 blur-3xl brightness-75"></div>
        <div className="h-52 w-52 bg-[#486654] absolute top-20 -left-10 z-1 blur-3xl brightness-75"></div>
        <div className="h-52 w-52 bg-[#65C28B] absolute top-20 left-40 z-1 blur-3xl brightness-50"></div>
      </div>
    </div>
  );
};

export default About;
